import React from 'react';
import { storiesOf } from '@storybook/react';
import ScheduleFilterModal from './ScheduleFilterModal';
import { action } from '@storybook/addon-actions';

storiesOf('Advanced Search/Result Form/Modals', module)
  .add('ScheduleFilterModal', () => (
    <ScheduleFilterModal
      show
      onClose={() => null}
      onSave={action('submitAdvancedSearch')}
      filter={filter}
    />
  ));

const filter = {};


// WEBPACK FOOTER //
// ./src/components/advancedSearch/resultForms/ScheduleFilterModal.stories.jsx